<div class="grid">
    <que-manipulations-toolbar *ngIf="!isEmpty$()" [displaySlideToggleType]="'groups'"></que-manipulations-toolbar>
    <div class="scroll" [ngClass]="{'expanded':!isFilterListOpen$()}" *ngIf="isResult$() ; else thereIsNotResult">
        <que-distribution-group-list-header class="position-sticky"></que-distribution-group-list-header>
        <div *ngFor="let item of distributionGroups$()?.result">
            <que-distribution-group-list-item [distributionGroup]="item"></que-distribution-group-list-item>
        </div>
        <ng-container *ngFor="let _ of [].constructor(3)">
            <div class="item-in-loading" *ngIf="loadingExtra$()"></div>
        </ng-container>
    </div>
</div>
<ng-template #thereIsNotResult>
    <div class="grid no-result" *ngIf="!loading$() else loading">
        <que-no-result [isEmpty]="isEmpty$()" [type]="'group'" (createEvent)="create()"></que-no-result>
    </div>
</ng-template>
<ng-template #loading>
    <div class="no-result" *ngIf="loading$()">
        <div *ngFor="let _ of [].constructor(10)" class="item-in-loading load-enimation"></div>
    </div>
</ng-template>